var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.66255C16.5 6.15755 16.095 6.56255 15.6 6.56255H2.4C1.905 6.56255 1.5 6.15755 1.5 5.66255V5.65505C1.5 3.93755 2.8875 2.55005 4.605 2.55005H13.3875C15.105 2.55005 16.5 3.94505 16.5 5.66255Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.5875V12.345C1.5 14.0625 2.8875 15.45 4.605 15.45H13.3875C15.105 15.45 16.5 14.055 16.5 12.3375V8.5875C16.5 8.0925 16.095 7.6875 15.6 7.6875H2.4C1.905 7.6875 1.5 8.0925 1.5 8.5875ZM6 12.9375H4.5C4.1925 12.9375 3.9375 12.6825 3.9375 12.375C3.9375 12.0675 4.1925 11.8125 4.5 11.8125H6C6.3075 11.8125 6.5625 12.0675 6.5625 12.375C6.5625 12.6825 6.3075 12.9375 6 12.9375ZM10.875 12.9375H7.875C7.5675 12.9375 7.3125 12.6825 7.3125 12.375C7.3125 12.0675 7.5675 11.8125 7.875 11.8125H10.875C11.1825 11.8125 11.4375 12.0675 11.4375 12.375C11.4375 12.6825 11.1825 12.9375 10.875 12.9375Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBlack);
export default __webpack_public_path__ + "static/media/card-black.130ae34e8f780297f65aba762f93b478.svg";
export { ForwardRef as ReactComponent };